import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import messages from './messages';
import ReusableGridButton from '../../../components/grid-header/reusable-grid-button';
import { prepareToOpenNewOrderModal } from '../../../store/orders/edit-order/edit.order.actions';
import Global from '../../../store/global-selectors';

export const NewOrderButton = () => {
  const dispatch = useDispatch();
  const selectedCustomersCount = useSelector(Global.selectSelectedCustomersCount);
  const hasOrderManagementRole = useSelector(Global.selectUserhasOrderManagementRole);

  const isDisabled = selectedCustomersCount !== 1 || !hasOrderManagementRole;

  const actionHandler = useCallback(() => {
    dispatch(prepareToOpenNewOrderModal());
  }, [dispatch]);

  return <ReusableGridButton actionHandler={actionHandler} disable={isDisabled} messageDescriptor={messages.newOrder} theme='tertiary' />;
};
